// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__itxQm","s":"Icon_s__yCM07","m":"Icon_m__FjeYo","l":"Icon_l__sCOH8"};